import { Injectable } from '@angular/core';
import { BlipChat } from 'blip-chat-widget'

@Injectable({
  providedIn: 'root'
})
export class BlipChatService {
  private instance: any;

  init(appKey: string, customUrl?: string) {
    if (this.instance) return;

    this.instance = new BlipChat()
    .withAppKey(appKey)
    .withButton({
        color: '#0096fa',
        // icon: iconUrl
    })
    .withCustomCommonUrl(customUrl);

    this.instance.build();
  }

  close() {
    if (this.instance) {
      this.instance.destroy();
      this.instance = null;
    }
  }

  open() {
    if (this.instance) {
        this.instance.toogleChat();
    }
  }
}
